var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReelControlsRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21.6667L28.6167 21.6667L22.65 27.65L25 30L35 20L25 10L22.65 12.35L28.6167 18.3333L5 18.3333L5 21.6667Z",
    fill: "#2E3838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelControlsRight);
export default __webpack_public_path__ + "static/media/reel_controls_right.00c705bd99de9d0e96a18ab943019bfd.svg";
export { ForwardRef as ReactComponent };